import type { SpecsModel } from "./specsModel/SpecsModel";
import type { VersionModel } from "./specsModel/VersionModel";

export type PositionStyleAssignment = {
  label: string;
  styleKey: string;
  positionIds: string[];
};

export function getSelectedPositionForVersion(
  model: SpecsModel,
  productVersion: string,
  selectedPositionId: string | null
) {
  return (
    model.getVersion(productVersion)?.getSelectedPosition(selectedPositionId) ??
    null
  );
}

export function mutateSelectedPositionForVersion(
  model: SpecsModel,
  productVersion: string,
  selectedPositionId: string | null,
  mutator: (position: any, version: VersionModel) => void
) {
  const version = model.getVersion(productVersion);
  if (!version) {
    return;
  }
  return version.mutateSelectedPosition(selectedPositionId, (position) =>
    mutator(position, version)
  );
}

export function getSelectedPositionSideSnapshots(
  model: SpecsModel,
  productVersion: string,
  selectedPositionId: string | null
) {
  return (
    model
      .getVersion(productVersion)
      ?.getSelectedPositionSideSnapshots(selectedPositionId) ?? []
  );
}

export function getPositionStyleAssignments(
  model: SpecsModel,
  productVersion: string
): PositionStyleAssignment[] {
  return model.getVersion(productVersion)?.getPositionStyleAssignments() ?? [];
}

export function setStylePositionIdsForVersion(
  model: SpecsModel,
  productVersion: string,
  styleKey: string,
  positionIds: string[]
) {
  model.getVersion(productVersion)?.setStylePositionIds(styleKey, positionIds);
}

export function syncLockedSideDimension(
  version: VersionModel,
  position: any,
  dimension: "w" | "h",
  inches: number
) {
  const generator = position.generator;
  if (generator.allowIndependentScaling === true) {
    return;
  }
  const sides = generator.sides;

  const nextPixels = Math.round(inches * version.pixelToInch);
  position.generator = {
    ...generator,
    sides: sides.map((side: any) => ({ ...side, [dimension]: nextPixels })),
  };
}
